import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import analyticsService from '../utils/analytics';

import jwtDecode from 'jwt-decode';

import Sotyktu_PassHeader from '../shared/assets/sotyktu_header.svg';
import Zeposia_PassHeader from '../shared/assets/zeposia_header.svg';
import Camzyos_PassHeader from '../shared/assets/camzyos_header.svg';

import Sotyktu_PassAlert from '../shared/assets/sotyktu_alert.png';
import Zeposia_PassAlert from '../shared/assets/zeposia_alert.png';
import Camzyos_PassAlert from '../shared/assets/camzyos_alert.svg';

const useStyles = makeStyles(() => ({
    errorRoot: {
        gap: '10px',
        margin: '0px 20px'
    },
    sotyktu_header1: {
        fontWeight: '600 !important',
        color: '#4933DA',
        lineHeight: '1.35 !important'
    },
    zeposia_header1: {
        fontWeight: '600 !important',
        color: '#0054A6',
        lineHeight: '1.35 !important'
    },
    passAlert: {
        width: "150px",
        height: "100%",
        display: "flex",
        margin: "auto"
    },
    sotyktu_error_details: {
        lineHeight: 1.5
    }
}));

// const renderErrorContent = (type) => {
//     switch (type) {
//         case 'invalid_token': return <div>
//             The pass token is invalid or missing. Please try again or check with sms sender for token validity.
//         </div>
//         case 'addPass_fail': return <div>
//             Add to wallet failed. Please try again.
//         </div>
//         case 'passdata_invalid': return <div>
//             The pass data is invalid. Please check with sender for valid link.
//         </div>
//         case 'pass_expired': return <div>
//             Sorry, the following wallet pass has expired.
//         </div>
//         default: return <div>
//             Please navigate to the wallet sms and follow the steps to view your pass.
//         </div>;
//     }
// }

const Error = () => {
    const { state } = useLocation();
    const classes = useStyles();

    const [errorType, setErrorType] = useState('');
    const [pass, setPass] = useState();

    useEffect(() => {
        let digitalData = analyticsService.getDigitalData();
        digitalData['page_name'] = "Pass error page";
        analyticsService.setDigitalData(digitalData);

        const queryParams = new URLSearchParams(window.location.search);
        const queryToken = queryParams.get("data");
        if (queryToken) {
            try {
                const decodedToken = jwtDecode(queryToken);
                setPass(decodedToken.product);
            } catch (err) {
                // navigate(`/error`, { state: { error_type: 'invalid_token' } });
            }
        }

        if (state)
            setErrorType(state.error_type)
    }, [])

    const togglePageContent = () => {
        switch (pass) {
            case 'Sotyktu': return <div className={classes.errorRoot}>
                <img style={{ height: '125px' }} src={Sotyktu_PassHeader} />
                <hr
                    style={{
                        border: 0,
                        height: '7px',
                        background: 'linear-gradient(to right, #4933DA 0% ,#4933DA 50%, #D3019F 50%,#D3019F 75%, #96FF73 75% )',
                    }}
                ></hr>
                <br />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <Typography variant='h6' className={classes.sotyktu_header1}>
                        Something went wrong! <br />  Please try again.
                    </Typography>
                    <Typography variant='body' className={classes.sotyktu_error_details}>
                        If you have any questions, please contact <a style={{ color: '#4933DA' }} href='tel:+1-800-736-0003'><b>1-800-736-0003</b></a> Monday to Friday, 8 AM to 8 PM ET.
                    </Typography>
                    <img className={classes.passAlert} src={Sotyktu_PassAlert} />
                </div>
            </div>
            case 'Zeposia': return <div className={classes.errorRoot}>
                <img style={{ height: '125px', width: '100%' }} src={Zeposia_PassHeader} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <Typography variant='h6' className={classes.zeposia_header1}>
                        Something went wrong! <br />  Please try again.
                    </Typography>
                    <Typography variant='body' className={classes.sotyktu_error_details}>
                        If you have any questions, please contact <a style={{ color: '#0054A6' }} href='tel:+1-833-937-6742'><b>1-833-ZEPOSIA (937-6742)</b></a> Monday to Friday, 8 AM to 8 PM ET.
                    </Typography>
                    <img className={classes.passAlert} src={Zeposia_PassAlert} />
                </div>
            </div>
            case 'Camzyos': return <div className={classes.errorRoot}>
                <img style={{ height: '125px', width: '100%' }} src={Camzyos_PassHeader} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <Typography variant='h6' className={classes.zeposia_header1}>
                        Something went wrong! <br />  Please try again.
                    </Typography>
                    <Typography variant='body' className={classes.sotyktu_error_details}>
                        If you have any questions, please contact <a style={{ color: '#0054A6' }} href='tel:+1-888-768-9588'><b>1-888-CAMZYOS (768-9588)</b></a> Monday to Friday, 8 AM to 8 PM ET.
                    </Typography>
                    <img className={classes.passAlert} src={Camzyos_PassAlert} />
                </div>
            </div>
            default:
                return <div className={classes.errorRoot}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '50px' }}>
                        <Typography variant='h6' className={classes.zeposia_header1}>
                            Something went wrong! <br />  Please try again.
                        </Typography>
                        <img className={classes.passAlert} src={Camzyos_PassAlert} />
                    </div>
                </div>
        }
    }

    return (
        <>
            {togglePageContent()}
        </>
    )
}

export default Error